import { useState } from "react";
import { Check, Copy, ExternalLink, Info, X } from "lucide-react";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const LAKSMI_URL = "https://tiny.cc/LAKSMI";

export const ServiceNotice = ({ serviceId, onClose }) => {
  const [copyStatus, setCopyStatus] = useState("idle");
  const isLaksmi = serviceId === "laksmi";
  if (!serviceId) return null;

  const copyLink = async () => {
    try {
      if (!navigator.clipboard?.writeText) throw new Error("Clipboard API unavailable");
      await navigator.clipboard.writeText(LAKSMI_URL);
      setCopyStatus("copied");
    } catch (_) {
      setCopyStatus("failed");
    }
  };

  return (
    <AlertDialog open onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent className="padma-notice" data-testid={`service-notice-${serviceId}`}>
        <button type="button" className="padma-notice-close" onClick={onClose} aria-label="Tutup notifikasi" data-testid="service-notice-close">
          <X size={18} />
        </button>
        <div className={`padma-notice-icon ${isLaksmi ? "notice-sky" : "notice-amber"}`} aria-hidden="true"><Info size={25} /></div>
        <AlertDialogHeader>
          <AlertDialogTitle>{isLaksmi ? "Akses LAKSMI" : "MANTAB"}</AlertDialogTitle>
          <AlertDialogDescription data-testid="service-notice-message">
            {isLaksmi
              ? "Akses LAKSMI belum bisa melalui laman ini, silahkan akses LAKSMI pada laman :https://tiny.cc/LAKSMI"
              : "Laman dalam proses development"}
          </AlertDialogDescription>
        </AlertDialogHeader>
        {isLaksmi && (
          <div className="padma-notice-linkbox">
            <span data-testid="laksmi-url">{LAKSMI_URL}</span>
            <button type="button" onClick={copyLink} data-testid="laksmi-copy-link" aria-label="Salin tautan LAKSMI">
              {copyStatus === "copied" ? <Check size={16} /> : <Copy size={16} />}
            </button>
            {copyStatus !== "idle" && (
              <small className={`padma-copy-feedback ${copyStatus}`} data-testid="laksmi-copy-status" aria-live="polite">
                {copyStatus === "copied" ? "Tautan tersalin." : "Salin manual tautan di atas."}
              </small>
            )}
          </div>
        )}
        <AlertDialogFooter className="padma-notice-actions">
          <AlertDialogCancel className="padma-notice-secondary" data-testid="service-notice-understand">Mengerti</AlertDialogCancel>
          {isLaksmi && (
            <a className="padma-notice-primary" href={LAKSMI_URL} target="_blank" rel="noopener noreferrer" data-testid="laksmi-external-link">
              Buka LAKSMI <ExternalLink size={16} />
            </a>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};